import React from "react";
import {TextField, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import {fromApp} from "../../../../config/values";

const RayaField = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    let label = props.optional ? `${props.label}${t('optionalField')}` : props.label
    return (
        <>
            {
                !!fromApp() &&
                <Typography className="app-label">{label}</Typography>
            }
            <TextField
                {...props}
                required={false}
                label={!fromApp() ? label : ''}
                color="field"
                className={clsx('raya-field', props.className)}
                inputRef={ref}  // Forward the ref to the actual TextField
            />
        </>

    );
});

export default RayaField;
